import axios from "axios";
import { baseUrl } from "../util";

export const getProcessingSoldIntermediateTotal = ({
  businessId,
  setTotalObj = function () {
    return;
  },
  setSystemBoundary = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/processing-intermediate",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundary(response.data.total_obj.systemboundary_category);
    })
    .catch(function (error) {
      console.log(error);
    });
};
